import ShareableLinkNdaProcessing from './ShareableLinkNdaProcessing.component';

export default ShareableLinkNdaProcessing;